module.exports = __webpack_public_path__ + "img/thumbnail_PereDavidsDeer_j_normal.f62bfa48.png";